import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    bellerophonXmlReports: [],
    count: 0,
    page: 1,
    pageSize: 5,
    pages: 0,
    sortField: 'created_at',
    sortOrder: 'desc',
    search: null,
    error: '',
    reportUpdate: false,
    bellerophonXmlReportId: null,
    bellerophonXmlCountBatches: [],
    bxcbCount: 0,
    bxcbPage: 1,
    bxcbPageSize: 5,
    bxcbPages: 0,
    bxcbSortField: 'created_at',
    bxcbSortOrder: 'desc',
    bxcbSearch: null,
    bxcbError: '',
    bellerophonXmlCountBatchId: null,
    bellerophonXmlCountBatchWorkers: [],
    yyyymmddPrefix: '',
    bxcbwCount: 0,
    bxcbwPage: 1,
    bxcbwPageSize: 5,
    bxcbwPages: 0,
    bxcbwSortField: 'created_at',
    bxcbwSortOrder: 'desc',
    bxcbwSearch: null,
    bxcbwError: ''
}

const receivedBellerophonXmlReportsData=(state, action)=>{
    const { results,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        bellerophonXmlReports: results,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        search: search,
        reportUpdate: false
    }
}

const getBellerophonXmlReportsError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

const receivedBellerophonXmlCountBatchesData=(state, action)=>{
    const { results,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        bellerophonXmlCountBatches: results,
        bellerophonXmlReportId: action.bellerophonXmlReportId,
        bxcbCount: count,
        bxcbPage: page,
        bxcbPageSize: pageSize,
        bxcbPages: pages,
        bxcbSortField: sortField,
        bxcbSortOrder: sortOrder,
        bxcbSearch: search
    }
}

const getBellerophonXmlCountBatchesError=(state, action)=> {
    return {
        ...state,
        bxcbError: action.error
    }
}

const receivedBellerophonXmlCountBatchWorkersData=(state, action)=>{
    const { results,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    const bellerophonXmlCountBatch = state.bellerophonXmlCountBatches.find(item => item.id==action.bellerophonXmlCountBatchId)
    
    return {
        ...state,
        bellerophonXmlCountBatchWorkers: results,
        bellerophonXmlCountBatchId: action.bellerophonXmlCountBatchId,
        yyyymmddPrefix: bellerophonXmlCountBatch.yyyymmdd_prefix,
        bxcbwCount: count,
        bxcbwPage: page,
        bxcbwPageSize: pageSize,
        bxcbwPages: pages,
        bxcbwSortField: sortField,
        bxcbwSortOrder: sortOrder,
        bxcbwSearch: search
    }
}

const getBellerophonXmlCountBatchWorkersError=(state, action)=> {
    return {
        ...state,
        bxcbwError: action.error
    }
}

const triggeredBellerophonXmlCountReport=(state)=>{
    return {
        ...state,
        reportUpdate: true
    }
}
export default reduce(initialState,{
    [actionTypes.GET_BELLEROPHON_XML_COUNT_RPT_DATA]: receivedBellerophonXmlReportsData,
    [actionTypes.GET_BELLEROPHON_XML_COUNT_RPT_DATA_ERROR]: getBellerophonXmlReportsError,
    [actionTypes.GET_BELLEROPHON_XML_COUNT_BATCH_DATA]: receivedBellerophonXmlCountBatchesData,
    [actionTypes.GET_BELLEROPHON_XML_COUNT_BATCH_DATA_ERROR]: getBellerophonXmlCountBatchesError,
    [actionTypes.GET_BELLEROPHON_XML_COUNT_BATCH_WORKER_DATA]: receivedBellerophonXmlCountBatchWorkersData,
    [actionTypes.GET_BELLEROPHON_XML_COUNT_BATCH_WORKER_DATA_ERROR]: getBellerophonXmlCountBatchWorkersError,
    [actionTypes.TRIGGER_BELLEROPHON_XML_COUNT_REPORT]: triggeredBellerophonXmlCountReport
});


// WEBPACK FOOTER //
// ./src/redux/bellerophonXmlCount/reducer.js